import BuildingTreeIcon from './BuildingTreeIcon'

export default BuildingTreeIcon
